<template>
  <div class="beefCont">
    <img src="../assets/imgs/101/bg.jpg" class="bg" alt="" />
    <Qrcode :pic="101" :bottom="'1.7rem'" />
    <div class="phoneCommon">
        咨询电话：<a href="tel:028-87705569" style="color:#fff">028-87705569</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/public.scss";
.beefCont {
  width: 100vw;
  position: relative;
  .bg {
    width: 100%;
    height: 78.13rem;
    display: block;
  }
}
</style>